<div class="emoticon-reactions d-flex justify-content-start">
  @for (reaction of reactions; track reaction.id) {
    @if (reaction.count > 0) {
      <span class="emoticon-reaction d-block"
            [matTooltip]="reaction.count + ' ' + (reaction.label | translate)"
            matTooltipPosition="above">
          @if (reaction.smiley) {
            <span>{{reaction.smiley}} <small>{{reaction.count}}</small></span>
          } @else {
            <span><i class="{{reaction.icon}}"></i> <small>{{reaction.count}}</small></span>  
          }
      </span>
    }
  }
</div>
